import * as THREE        from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';



const viewHeight = 1.85;

const colors = {
  background: { color: 0xf0f5f9 },
  floor:      { color: 0xcccccc },
  wood:       { color: 0x8b5a2b, roughness: 0.9 },
  book:       { color: 0x3a5a40, roughness: 0.7 },
  skin:       { color: 0xffccaa },
  shirt:      { color: 0x2b5797 },
  pants:      { color: 0x333333 },
};

const materials = Object.fromEntries(
  Object.entries(colors).map(
    ([name, data]) => [name, new THREE.MeshStandardMaterial(data)]
  )
);

const apiData = [
  {
    id: 1,
    pos: { x: -4, z: -3 },
    size: { width: 2.5, depth: 1, height: 2.5 },
    sections: [
      { title: "Фантастика", desc: "Азимов, Кларк, Хайнлайн" },
      { title: "Киберпанк",  desc: "Гибсон, Стивенсон"       },
      { title: "Антиутопии", desc: "Оруэлл, Хаксли, Замятин" },
    ],
  },
  {
    id: 2,
    pos: { x: 2, z: -3 },
    size: { width: 1, depth: 1, height: 1.5 },
    sections: [
      { title: "Физика",     desc: "Квантовая механика, теория струн" },
      { title: "Математика", desc: "Линейная алгебра, матанализ"      },
    ],
  },
  {
    id: 3,
    pos: { x: -4, z: 3 },
    size: { width: 2.5, depth: 1, height: 2.5 },
    sections: [
      { title: "Детективы: Классика",    desc: "Агата Кристи, Конан Дойл" },
      { title: "Нуар",                   desc: "Чандлер, Хэммет"          },
      { title: "Скандинавский детектив", desc: "Несбё, Ларссон"           },
      { title: "Триллеры",               desc: "Стивен Кинг, Финчер"      },
    ]
  },
];



const scene = new THREE.Scene();
scene.background = new THREE.Color(colors.background.color);

const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(0, 3, 8);

const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);

const controls = new OrbitControls(camera, renderer.domElement);
controls.enableZoom    = true;
controls.enablePan     = false;
controls.enableDamping = true;
controls.target.set(0, viewHeight, 0);
controls.minPolarAngle = Math.PI / 4;
controls.maxPolarAngle = Math.PI / 2 - 0.05;
controls.dampingFactor = 0.05;

scene.add(new THREE.AmbientLight(0xffffff, 0.7));
const dirLight = new THREE.DirectionalLight(0xffffff, 0.6);
dirLight.position.set(10, 15, 10);
scene.add(dirLight);



const objectsToIntersect = [];
const objectsToHide = []



const floorGeometry = new THREE.PlaneGeometry(50, 50);
const floor = new THREE.Mesh(floorGeometry, materials.floor);
floor.rotation.x = -Math.PI / 2;
scene.add(floor);
objectsToIntersect.push(floor);



const person = new THREE.Group();

const head = new THREE.Mesh(new THREE.SphereGeometry(0.25, 16, 16), materials.skin);
head.position.y = 1.7;
person.add(head);

const body = new THREE.Mesh(new THREE.CylinderGeometry(0.3, 0.3, 0.7), materials.shirt);
body.position.y = 1.1;
person.add(body);

const armGeometry = new THREE.CylinderGeometry(0.08, 0.08, 0.7);
const leftArm = new THREE.Mesh(armGeometry, materials.skin);
leftArm.position.set(-0.45, 1.1, 0);
const rightArm = new THREE.Mesh(armGeometry, materials.skin);
rightArm.position.set(0.45, 1.1, 0);
person.add(leftArm, rightArm);

const legGeometry = new THREE.CylinderGeometry(0.12, 0.12, 0.8);
const leftLeg = new THREE.Mesh(legGeometry, materials.pants);
leftLeg.position.set(-0.15, 0.4, 0);
const rightLeg = new THREE.Mesh(legGeometry, materials.pants);
rightLeg.position.set(0.15, 0.4, 0);
person.add(leftLeg, rightLeg);

scene.add(person);



apiData.forEach(rackData => {
  const rackGroup = new THREE.Group();
  rackGroup.position.set(rackData.pos.x, 0, rackData.pos.z);

  const numSections = rackData.sections.length;
  const sectionHeight = rackData.size.height / numSections;

  rackData.sections.forEach((sectionInfo, index) => {
    const shelfGroup = new THREE.Group();
    shelfGroup.position.y = (index * sectionHeight) + (sectionHeight / 2);

    const baseGeom = new THREE.BoxGeometry(rackData.size.width, 0.1, rackData.size.depth);
    const baseMesh = new THREE.Mesh(baseGeom, materials.wood);
    baseMesh.position.y = -sectionHeight / 2 + 0.05;

    const booksGeom = new THREE.BoxGeometry(rackData.size.width - 0.2, sectionHeight - 0.2, rackData.size.depth - 0.2);

    const currentBookMaterial = materials.book.clone();
    const booksMesh = new THREE.Mesh(booksGeom, currentBookMaterial);

    booksMesh.userData = {
      isShelf: true,
      title: sectionInfo.title,
      desc: sectionInfo.desc
    };

    shelfGroup.add(baseMesh);
    shelfGroup.add(booksMesh);
    rackGroup.add(shelfGroup);

    objectsToIntersect.push(booksMesh);
  });

  scene.add(rackGroup);
  objectsToHide.push(rackGroup);
});

const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

let activeShelf = null;

const infoPanel = document.getElementById('infoPanel');
const infoTitle = document.getElementById('infoTitle');
const infoDesc  = document.getElementById('infoDesc');

function clearHighlight() {
  if (activeShelf) {
    activeShelf.material.emissive.setHex(0x000000);
    activeShelf = null;
    infoPanel.style.display = 'none';
  }
}

window.addEventListener('dblclick', (event) => {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(objectsToIntersect);

  if (intersects.length > 0) {
    const object = intersects[0].object;
    const point = intersects[0].point;

    if (object.userData.isShelf) {
      if (activeShelf !== object) {
        clearHighlight();

        activeShelf = object;
        activeShelf.material.emissive.setHex(0x333333);

        infoTitle.textContent = object.userData.title;
        infoDesc.textContent = object.userData.desc;
        infoPanel.style.display = 'block';
      }
    } else {
      clearHighlight();
    }
  } else {
    clearHighlight();
  }
});

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});

function animate() {
  requestAnimationFrame(animate);

  controls.update();

  person.rotation.y = Math.atan2(camera.position.x, camera.position.z);

  objectsToHide.forEach(rack => {
    const dot =
      camera
      .position
      .clone()
      .normalize()
      .dot(rack.position.clone().normalize());

    rack.visible = dot <= 0.8;
  })

  renderer.render(scene, camera);
}

animate();
